const initialCardState = {
    cards: [ ],
    banks:  [ ],
    cardsLoaded: false,
    banksLoaded: false,
    cardError: ''
}

const cardReducer = (state = initialCardState, action) => {
    switch (action.type) {
        case 'LOAD_CARDS':
            return Object.assign({}, state, {
                cards: action.cards,
                cardsLoaded: true,
                cardError: ''
            })
        case 'LOAD_BANKS':
            return Object.assign({}, state, {
                banks: action.banks,
                banksLoaded: true
            })
        case 'ADD_SINGLE_CARD':
            return Object.assign({}, state, {
                cardsLoaded: false,
                cardError: 'Success'
            })
        case 'CARD_REFRESH_FLAG':
            return Object.assign({}, state, {
                cardsLoaded: false
            })
        case 'CARD_ERROR_MESSAGE':
            return Object.assign({}, state, {
                cardError: action.message
            })
        default:
            return state
    }
}

export default cardReducer;